import { useEffect } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { getScriptSrc, loadScript } from './utils/script';

export default function EmbedBlock({ html, condition, callback }) {
  const { scriptSrc, updatedHtml } = getScriptSrc(html);

  useEffect(() => {
    if (condition) {
      callback();
    } else {
      loadScript(scriptSrc);
    }
  }, []);

  return parse(DOMPurify.sanitize(updatedHtml));
}

EmbedBlock.propTypes = {
  html: PropTypes.string.isRequired,
  condition: PropTypes.bool,
  callback: PropTypes.func,
};

EmbedBlock.defaultProps = {
  condition: false,
  callback: () => {},
};
